// extracted by mini-css-extract-plugin
module.exports = {"resultsHeadBar":"AlgoliaSerpContainer_resultsHeadBar__sNjK1","resultsChips":"AlgoliaSerpContainer_resultsChips__z7EX_"};